import RereservationPageV2 from "@/public/components/features/rereservation/RereservationPageV2"

const RereservationV2 = () => {
	return <RereservationPageV2 />
}

export default RereservationV2
